/*
  access actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\access\saga.js
*/
const actions = {
  ACCESS_SEARCH: 'ACCESS_SEARCH',
  ACCESS_SEARCH_SUCCESS: 'ACCESS_SEARCH_SUCCESS',
  ACCESS_ACTIONS_SEARCH: 'ACCESS_ACTIONS_SEARCH',
  ACCESS_ACTIONS_SEARCH_SUCCESS: 'ACCESS_ACTIONS_SEARCH_SUCCESS',
  ACCESS_CREATE: 'ACCESS_CREATE',
  ACCESS_CREATE_SUCCESS: 'ACCESS_CREATE_SUCCESS',
  ACCESS_UPDATE: 'ACCESS_UPDATE',
  ACCESS_UPDATE_SUCCESS: 'ACCESS_UPDATE_SUCCESS',
  ACCESS_DELETE: 'ACCESS_DELETE',
  ACCESS_DELETE_SUCCESS: 'ACCESS_DELETE_SUCCESS',
  ACCESS_ERROR: 'ACCESS_ERROR',

  apiAccessFields: () => ({
    type: actions.ACCESS_FIELDS,
  }),

  apiAccesses: queryString => ({
    type: actions.ACCESS_SEARCH,
    queryString,
  }),

  apiAccessActions: queryString => ({
    type: actions.ACCESS_ACTIONS_SEARCH,
    queryString,
  }),

  apiAccessCreate: createdAccess => ({
    type: actions.ACCESS_CREATE,
    createdAccess,
  }),

  apiAccessUpdate: updatedAccess => ({
    type: actions.ACCESS_UPDATE,
    updatedAccess,
  }),

  apiAccessDelete: deletedAccess => ({
    type: actions.ACCESS_DELETE,
    deletedAccess,
  }),
};
export default actions;
